
import { SET_ACTIVE_TAB_STATE } from "./OrdersSetting.actions";

export interface IOrdersSettingState{
    activeTab:{
        key:string
    }
}

export const initalState:IOrdersSettingState = {
    activeTab:{
        key:"General"
    }
}

export function OrdersSettingReducer(state: IOrdersSettingState = initalState, action: { type: string, payload: any; }) {
    switch (action.type) {
        case SET_ACTIVE_TAB_STATE:
            return {
                ...state,
                activeTab: action.payload,
            };
    }
    return state;
}